import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class CreateDefaultWorkflowsFailedError extends CodedError {
  static get errorName() {
    return errorCodeTypes.createDefaultWorkflowsFailedError.code;
  }

  constructor(
    message = errorCodeTypes.createDefaultWorkflowsFailedError.message
  ) {
    super(message);
    this.code = errorCodeTypes.createDefaultWorkflowsFailedError.code;
    this.message = `${message} ${errorCodeTypes.createDefaultWorkflowsFailedError.code}`;
    this.name = errorCodeTypes.createDefaultWorkflowsFailedError.name;
  }
}
